
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/for-researches",
      function () {
        return require("private-next-pages/landing/for-researches.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/for-researches"])
      });
    }
  